import { Button, Container } from '@/components';
import FileUploadTemplate from '@/components/common/FileUpload/FileUploadTemplate';
import { useBts } from '@/context/btsContext/BtsContextProvider';
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const BtsUpload = () => {
  const { uploadBtsProductFile, isLoading, downloadBtsProductFile } = useBts();
  const [selectedFiles, setSelectedFiles] = useState([]);
  const navigate = useNavigate();

  const handleFilesSelected = (files) => {
    if (files.length !== 1) {
      alert('Please upload exactly one file.');
      return;
    }
    setSelectedFiles(files);
  };

  const handleUpload = async (files) => {
    if (files.length === 1) {
      await uploadBtsProductFile(files[0]);
      setSelectedFiles([]);
    } else {
      alert('Please select a file to upload.');
    }
  };

  const handleDownload = () => {
    downloadBtsProductFile();
  };

  return (
    <>
      <Container title={'BTS Upload'}>
        <div className="mb-6 ml-5">
          <Link
            to="/bts"
            className="inline-flex items-center text-blue-600 hover:text-blue-800 font-medium transition-colors duration-150 group"
          >
            <svg
              className="w-5 h-5 mr-1 group-hover:-translate-x-1 transition-transform duration-150"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15 19l-7-7 7-7"
              />
            </svg>
            <span>Back to BTS</span>
          </Link>
        </div>
        <div className="mb-4 flex items-center">
          <h2 className="text-xl font-semibold flex-1 text-center">
            BTS Upload
          </h2>
        </div>
        <div>
          <p className="text-gray-500 mb-6 text-center">
            Please upload an Excel file containing BTS product data.
          </p>
          <FileUploadTemplate
            acceptedFileTypes={['.csv']}
            onFilesSelected={handleFilesSelected}
            multiple={false}
            onUpload={handleUpload}
            maxFiles={1}
            isLoading={isLoading}
          />
          <div className="my-6 flex justify-center">
            <Button onClick={handleDownload} disabled={isLoading}>
              Download BTS Product File
            </Button>
          </div>
          <div className="overflow-x-auto rounded-lg bg-gray-50 shadow-sm mt-8">
            <h3 className="text-lg font-semibold text-center mb-2">
              Reference Table
            </h3>
            <table className="min-w-full divide-y divide-gray-200 text-sm text-gray-700">
              <thead className="bg-gray-100">
                <tr>
                  <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                    Item Code
                  </th>
                  <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                    Conv Factor
                  </th>
                  <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                    BTS Price
                  </th>
                  <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                    Normal Price
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {/* Example row, replace with real data if needed */}
                <tr>
                  <td className="py-2 px-4 text-center">ITEM001</td>
                  <td className="py-2 px-4 text-center">10</td>
                  <td className="py-2 px-4 text-center">500</td>
                  <td className="py-2 px-4 text-center">600</td>
                </tr>
                <tr>
                  <td className="py-2 px-4 text-center">ITEM002</td>
                  <td className="py-2 px-4 text-center">5</td>
                  <td className="py-2 px-4 text-center">250</td>
                  <td className="py-2 px-4 text-center">300</td>
                </tr>
                {/* Add more rows as needed */}
              </tbody>
            </table>
          </div>
        </div>
      </Container>
    </>
  );
};

export default BtsUpload;
